import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import FinanceReferencesLayer from '../components/FinanceReferencesLayer';

const FinanceReferencesPage = () => (
  <MasterLayout pageTitle='Finance Reference Tables'>
    <FinanceReferencesLayer />
  </MasterLayout>
);

export default FinanceReferencesPage;
